/* eslint-disable import/no-cycle */
import NavbarMenu from "./NavbarMenu/NavbarMenu"
import useStyles from "./styles"
import MobileSearchArea from "./SearchArea/MobileSearchArea"
import DesktopSearchArea from "./SearchArea/DesktopSearchArea"
import { Menu2Drawer, SpeedOrderNavbar } from ".."
import largeLogo from "../../assets/largelogo.png"
import logo from "../../assets/logo.png"
import { productViewBreakpoint } from "../../lib/helper/viewportHelper"
import { useLanguage } from "../../lib/hooks/languageHooks"
import { strings as Localization } from "../../lib/Localization"
import useCookiesConsent from "../../redux/hook/gdprHooks"
import { useIsShowingNavbarSearch, useProxyPath } from "../../redux/hook/settingsHooks"
import { useIsUserAuthorized } from "../../redux/hook/userHooks"
import { setProxyPath, setRecaptchaSiteKey, setShowNavbarSearch } from "../../redux/settingsReducer"
import theme from "../../theme"
import { Link, useHistory } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import React, {
    useEffect, useRef, useState
} from "react"
import PermIdentityIcon from "@material-ui/icons/PermIdentity"
import { ShoppingCart } from "@material-ui/icons"
import {
    AppBar, Badge, Box, Button, Toolbar, Tooltip, useMediaQuery
} from "@material-ui/core"

const Navbar = () => {
    const language = useLanguage()
    const dispatch = useDispatch()
    const otherLang = language === "sv" ? "en" : "sv"
    const classes = useStyles()
    const isAuthorized = useIsUserAuthorized()
    const cart = useSelector(state => state.cart)
    const [drawerIsOpen, setDrawerIsOpen] = useState(false)
    const proxyPath = useProxyPath()
    const acceptedCookies = useCookiesConsent()
    const navbarRef = useRef()
    const isSmall = useMediaQuery(theme.breakpoints.down(productViewBreakpoint))
    const showingSearch = useIsShowingNavbarSearch()
    const history = useHistory()

    useEffect(() => {
        dispatch(setProxyPath(process.env.REACT_APP_PROXY_PATH))
        dispatch(setRecaptchaSiteKey(process.env.REACT_APP_RECAPTCHA_SITEKEY))
    }, [])

    const changeLanguage = () => window.location.pathname.replace(language, otherLang)

    const handleOpenDrawer = () => {
        setDrawerIsOpen(prev => !prev)
    }

    const handleBackDropClick = () => {
        setDrawerIsOpen(false)
    }

    const showSearch = () => {
        dispatch(setShowNavbarSearch(true))
    }

    const hideSearch = () => {
        dispatch(setShowNavbarSearch(false))
    }

    const handleOnClick = () => history.push(`${proxyPath}/${language}`)

    return (
        <>
            <AppBar ref={navbarRef} position="sticky" className={classes.appBar} color="inherit">
                <Toolbar className={classes.toolbar} disableGutters>
                    <Box
                        sx={{ display: { xs: "none", sm: "block" } }}
                        className={classes.logo}
                        component={Link}
                        to={`${proxyPath}/${language}`}
                        onClick={handleOnClick}
                    >
                        <img
                            src={largeLogo}
                            alt="Brodit logo"
                            className={classes.image}
                            style={{ height: "100%" }}
                        />
                    </Box>
                    <Box
                        className={classes.flexContainer}
                        style={{ justifyContent: "center", flexDirection: "column" }}
                    >
                        <Box>
                            <Box
                                className={classes.flexContainer}
                                style={{ justifyContent: "space-between", alignItems: "center" }}
                            >
                                <Box
                                    className={classes.flexContainer}
                                    sx={{ justifyContent: { xs: "space-between", sm: "flex-end" }, alignItems: "start" }}
                                >
                                    <Box
                                        sx={{ display: { xs: "block", sm: "none" }, maxWidth: "50%" }}
                                        className={classes.logo}
                                        component={Link}
                                        to={`${proxyPath}/${language}`}
                                        onClick={handleOnClick}
                                    >
                                        <img
                                            src={logo}
                                            alt="Brodit logo"
                                            className={classes.image}
                                            style={{ height: "100%" }}
                                        />
                                    </Box>
                                    <Box style={{ display: "flex", flexDirection: "row" }}>
                                        {
                                            isAuthorized
                                                ? (
                                                    <>
                                                        <Box>
                                                            <SpeedOrderNavbar />
                                                        </Box>
                                                        <Box style={{ marginRight: "1rem" }}>
                                                            <Tooltip title={Localization.cart}>
                                                                <Button
                                                                    // eslint-disable-next-line max-len
                                                                    to={`${proxyPath}/${language}/cart`}
                                                                    component={Link}
                                                                    aria-label="Show cart items"
                                                                    endIcon={(
                                                                        <Badge
                                                                            // eslint-disable-next-line max-len
                                                                            badgeContent={cart.items.length}
                                                                            color="primary"
                                                                            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                                                                            classes={{
                                                                                // eslint-disable-next-line max-len
                                                                                anchorOriginBottomRightRectangular: classes.badgePos,
                                                                                badge: classes.badge
                                                                            }}
                                                                        >
                                                                            <ShoppingCart />
                                                                        </Badge>
                                                                    )}
                                                                >
                                                                    {Localization.cart}
                                                                </Button>
                                                            </Tooltip>
                                                        </Box>
                                                        <Box style={{ width: 140 }}>
                                                            <NavbarMenu />
                                                        </Box>
                                                    </>
                                                )
                                                : (
                                                    <Box>
                                                        <Button
                                                            id="login"
                                                            to={`${proxyPath}/${language}/signin`}
                                                            component={Link}
                                                            aria-label="Log in"
                                                            endIcon={<PermIdentityIcon />}
                                                            disabled={!acceptedCookies}
                                                        >
                                                            {Localization.logIn}
                                                        </Button>
                                                    </Box>
                                                )
                                        }
                                        <Box>
                                            <Tooltip title={Localization.toggleLanguage}>
                                                <Button
                                                    id="languageBtn"
                                                    component={Link}
                                                    to={changeLanguage()}
                                                    aria-label="Toggle language"
                                                    style={{ height: 40 }}
                                                >
                                                    {otherLang}
                                                </Button>
                                            </Tooltip>
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                        {!isSmall
                            && (
                                <DesktopSearchArea
                                    handleOpenDrawer={handleOpenDrawer}
                                    drawerIsOpen={drawerIsOpen}
                                />
                            )}
                        {(isSmall && showingSearch)
                            && (
                                <Button onClick={() => hideSearch()} style={{ justifyContent: "flex-end" }}>
                                    {Localization.hideSearch}
                                </Button>
                            )}
                        {(isSmall && !showingSearch)
                            && (
                                <Button onClick={() => showSearch()} style={{ justifyContent: "flex-end" }}>
                                    {Localization.showSearch}
                                </Button>
                            )}
                        {(isSmall)
                            && (
                                <MobileSearchArea
                                    showingSearch={showingSearch}
                                    handleOpenDrawer={handleOpenDrawer}
                                    drawerIsOpen={drawerIsOpen}
                                />
                            )}
                    </Box>
                </Toolbar>
            </AppBar>
            <Menu2Drawer
                BackdropProps={{ invisible: true }}
                open={drawerIsOpen}
                variant="temporary"
                PaperProps={{ className: classes.drawerPaper }}
                onClose={handleBackDropClick}
                toggleDrawer={handleOpenDrawer}
            />
        </>
    )
}

export default Navbar
